import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CircleContainer = styled.div`
  color: #fff;
  width: 3.2rem;
  aspect-ratio: 1;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background-color: ${(props) => props.backgroundColor || '#FFF'};
`;

/**
 * Componente que renderiza um círculo com número/valor centralizado
 *
 * @param {Object} props - Propriedades do componente
 * @param {string} props.title - Texto de título/tooltip do círculo
 * @param {string|number} props.value - Valor a ser exibido no centro do círculo
 * @param {string} props.backgroundColor - Cor de fundo do círculo
 * @returns {JSX.Element} Componente CircleNumber
 */
export const CircleNumber = ({ title, value, backgroundColor, ...props }) => {
  return (
    <CircleContainer backgroundColor={backgroundColor} {...props}>
      {value}
    </CircleContainer>
  );
};

CircleNumber.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  backgroundColor: PropTypes.string
};

CircleNumber.defaultProps = {
  title: '',
  backgroundColor: '#FFF'
};
